<form
  class="contact-form"
  [formGroup]="contactFormGroup()"
>
  @for (field of contactFormFields; track $index) {
    @if (field.type !== 'select') {
      <mat-form-field
        appearance="outline"
        [class]="getClasses()"
        [style.cursor]="getFieldStyles(field.fieldName)"
        (click)="handleOpenUrlClick(field.fieldName)"
      >
        <mat-label>
          {{ field.label }}
        </mat-label>
        <input
          matInput
          [type]="field.type"
          [formControlName]="field.fieldName"
          (blur)="handleFieldChange(field.fieldName)"
        >
      </mat-form-field>
    } @else {
      <mat-form-field
        appearance="outline"
        [class]="getClasses()"
      >
        <mat-label>
          {{field.label}}
        </mat-label>
        <mat-select
          [formControlName]="field.fieldName"
          (selectionChange)="handleFieldChange(field.fieldName)"
        >
          @for (option of telegramAccountIds(); track $index) {
            <mat-option [value]="option.id">
              {{ option.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
</form>
@if (currentContactIndex() >= 0 && contactsDialogData()?.fromBloggerProfile) {
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="handleDeleteContact(currentContactIndex())"
    >
      Удалить контакт
    </button>
  </div>
}
@if (selectedTabIndex() === 1) {
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="handleAttachClick.emit()"
    >
      Прикрепить
    </button>
  </div>
}
